import { ViewFactory } from 'wdc-cube-react'
import { TimePickerScope } from '..'
import { TimePickerView } from './TimePicker.view'

export function registerViews(rv = ViewFactory.register) {
    rv(TimePickerScope, TimePickerView)
}
